import {useContext} from 'react';
import {
  Platform,
} from 'react-native';
import {
  NativeBaseProvider,
  StatusBar,
  Box,
} from 'native-base';
import { Context } from './contexts/GlobalContext';
import {
  Routes,
} from './routes';
import {
  THEME_LIGHT_COLOR,
  THEME_DARK_COLOR,
} from './styles';

export function AppIndex(){
  const { state } = useContext(Context);
  return(
<NativeBaseProvider theme={
      state.colorScheme === 'dark' ? THEME_DARK_COLOR : THEME_LIGHT_COLOR
    }>
      {
        Platform.OS !== 'web' &&
        <StatusBar
          barStyle={state.colorScheme !== 'dark' ? "dark-content" : "light-content"}
          backgroundColor="transparent"
          translucent
        />
      }
      {
        <Box flex={1} safeArea safeAreaTop={0}>
          <Routes/>
        </Box>
      }
    </NativeBaseProvider>
  )
}